import { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import clsx from 'clsx'

import { setHeaderExpandedHeight } from 'app/redux/widget/widget.actions'
import AcceptedChatHeader from '../../acceptedChat/header'
import { TeamChatHeader } from 'app/containers/widget/launcher/components'
import ArrowBackIcon from '../../components/backArrow'
import { LAUNCHER_CONTENT_STATE } from 'app/constants/launcherContentStates'
import CloseWidgetBtn from 'app/components/CloseWidgetBtn'
import LinearAvatarsCollection from 'app/components/LinearAvatarsCollection'
import ClamedText from 'app/components/ClampedText'
import './header.scss'

const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo
const getAcceptedChat = ({ messagesData }) => messagesData.acceptedChat
const getHeaderExpand = ({ widgetData }) => widgetData.widgetInfo.headerExpand
const getActiveDepartment = ({ messagesData }) => messagesData.activeDepartment.data
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data.teams
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq
const getLuancherInfo = ({ widgetData }) => widgetData.widgetInfo.launcherInfo
const getIsWidgetWideOpen = ({ widgetData }) => widgetData.widgetInfo.isWidgetWideOpen
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

const Header = () => {
  const widgetInfo = useSelector(getWidgetInfo)
  const acceptedChat = useSelector(getAcceptedChat)
  const headerExpand = useSelector(getHeaderExpand)
  const activeDepartment = useSelector(getActiveDepartment)
  const departments = useSelector(getDepartments)
  const faqs = useSelector(getFaqs)
  const launcherInfo = useSelector(getLuancherInfo)
  const isWidgetWideOpen = useSelector(getIsWidgetWideOpen)
  const languageInfo = useSelector(getLanguageInfo)

  const isDepartmentNumMoreThanOne = departments && departments.length > 1
  const anyActiveFaq = !!faqs.length
  const showBackArrow = isDepartmentNumMoreThanOne || anyActiveFaq
  const dispatch = useDispatch()

  const headerRef = useRef()

  const department = departments?.find((item) => item._id === activeDepartment)
  const operatorsNum = department?.operators.length || 0

  const operatorsAvatarsNum = operatorsNum >= 3 ? 3 : operatorsNum
  const operatorsAvatarsWidth = operatorsAvatarsNum * 50 - (operatorsAvatarsNum - 1) * 30

  const customCssVariables = {
    '--raychat-chat-header-bg':
      launcherInfo.content === LAUNCHER_CONTENT_STATE.MAIN_COVER ? 'none' : 'var(--primary-color)',
    '--raychat-chat-header-wp':
      launcherInfo.content === LAUNCHER_CONTENT_STATE.MAIN_COVER ? 'none' : 'var(--widget-wallpaper)',
    '--raychat-avatars-container-width': `${operatorsAvatarsWidth}px`,
  }

  const headerTitle = widgetInfo.data.personalize.title
  const headerDescription = widgetInfo.data.personalize.title2

  const getTooltipDirection = () => {
    if (languageInfo.general.direction === 'ltr') {
      return 'right'
    }

    return 'left'
  }

  const getAcceptedChatTitle = (info) => {
    const { agentInfo } = info

    if (agentInfo) {
      return agentInfo.name
    }

    if (info.isBot) {
      return languageInfo.texts.chatBotText
    }

    return ''
  }

  const getAcceptedChatSubtitle = (info) => {
    const { agentInfo } = info

    if (agentInfo) {
      return agentInfo.title
    }

    return ''
  }

  const getHeaderAvatar = (info) => {
    const { agentInfo } = info

    if (agentInfo) {
      return agentInfo.avatar
    }

    return ''
  }

  useEffect(() => {
    setTimeout(() => {
      const headerHeight = headerRef.current?.clientHeight

      if (headerHeight && !isWidgetWideOpen) {
        dispatch(setHeaderExpandedHeight(headerHeight))
      }
    }, 350)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerRef.current, isWidgetWideOpen])

  const renderChatHeader = () => {
    const acceptedChatInfo = acceptedChat[activeDepartment]

    if (acceptedChatInfo) {
      return (
        <AcceptedChatHeader
          title={getAcceptedChatTitle(acceptedChatInfo)}
          subTitle={getAcceptedChatSubtitle(acceptedChatInfo)}
          avatar={getHeaderAvatar(acceptedChatInfo)}
          showBackArrow={showBackArrow}
          acceptedByBot={acceptedChatInfo.isBot}
        />
      )
    }

    if (department && departments.length > 1) {
      return <TeamChatHeader department={department} />
    }

    if (department) {
      // show this header if there is just one department and no chat is accepted yet
      return (
        <div className="chat_header_wrapper" style={customCssVariables}>
          <div ref={headerRef} className={clsx('chat_header', headerExpand ? 'expanded' : 'chat_header_collapsed')}>
            <div className="chat_header_description_container not_expanded">
              <div className="chat_header_avatar_container">
                {!widgetInfo.data.personalize?.hideOperator && (
                  <LinearAvatarsCollection
                    tooltipDirection={getTooltipDirection()}
                    tooltipDistanceFromAvatar={5}
                    showTooltip={true}
                    avatarSize={36}
                    operators={department.operators.slice(0, operatorsAvatarsNum)}
                  />
                )}
              </div>

              <div className="header_title_wrapper">
                {/* title */}
                <div className="chat_header_title_container">
                  <ClamedText className="chat_header_title" linesNum={2} maxChar={60} text={headerTitle} />
                </div>

                {/* description */}
                <div className="chat_header_description">
                  <ClamedText className="chat_header_title" linesNum={2} maxChar={60} text={headerDescription} />
                </div>
              </div>
            </div>

            <div className="chat_header_actions">
              <CloseWidgetBtn />
              {showBackArrow && <ArrowBackIcon />}
            </div>
          </div>
        </div>
      )
    }
  }

  return <div style={{ zIndex: '999999999' }}>{renderChatHeader()}</div>
}

export default Header
